// src/data/moduleTools.js
// The module → toolkit pairing, used by the module reader's "Practise this now"
// card. Keep in step with the registry in src/pages/ToolkitPage.jsx (ids, titles
// and times are duplicated here deliberately so the reader never has to import
// the page and drag its eighteen lazy tool chunks into the reading flow).
export const MODULE_TOOLS = {
  1: [
    { id: 'three-question-filter', title: 'The Three-Question Filter', time: '1-2 mins' },
    { id: 'socratic-dialogue-simulator', title: 'Socratic Dialogue Journal', time: '15-20 mins' }
  ],
  2: [
    { id: 'fallacy-detective', title: 'Fallacy Detective', time: '10-15 mins' },
    { id: 'argument-builder', title: 'Argument Builder', time: '10-15 mins' }
  ],
  3: [
    { id: 'credible-evaluator', title: 'CREDIBLE Framework Evaluator', time: '15-20 mins' },
    { id: 'epistemic-confidence-calibrator', title: 'Epistemic Confidence Calibrator', time: '5 mins per entry' },
    { id: 'assumption-excavator', title: 'Assumption Excavator', time: '20 mins' }
  ],
  4: [
    { id: 'ethical-framework-analyzer', title: 'Ethical Framework Analyser', time: '20-25 mins' },
    { id: 'personal-ethics-auditor', title: 'Personal Ethics Auditor', time: '20-25 mins' }
  ],
  5: [
    { id: 'personal-identity-explorer', title: 'Personal Identity Explorer', time: '20-25 mins' },
    { id: 'free-will-tracker', title: 'Free Will Experience Tracker', time: '5 mins per entry' }
  ],
  6: [
    { id: 'chinese-room-interactive', title: 'Chinese Room Interactive', time: '15 mins' },
    { id: 'qualia-journal', title: 'Qualia Investigation Journal', time: '5-10 mins per entry' }
  ],
  7: [
    { id: 'political-philosophy-mapper', title: 'Political Philosophy Mapper', time: '10-15 mins' },
    { id: 'veil-of-ignorance-analyzer', title: 'Veil of Ignorance Analyser', time: '15 mins' },
    { id: 'original-position', title: 'The Original Position (game)', time: '10-15 mins' }
  ],
  8: [
    { id: 'existential-choice-analyzer', title: 'Existential Choice Analyser', time: '15-20 mins' },
    { id: 'meaning-creation-workshop', title: 'Meaning Creation Workshop', time: '25-30 mins' }
  ]
};

export const getToolsForModule = (moduleOrder) => MODULE_TOOLS[moduleOrder] || [];
